import { executeStandardRequest } from '@musinsa/packages-http';
import { privateHttpClient } from '../httpClient';
import { salesRankingQueryKeys } from './queryKeys';
import type { GetSalesRankingAvailableYearMonthsResponse } from './types';

export const getSalesRankingAvailableYearMonths = () =>
  executeStandardRequest(() =>
    privateHttpClient.get<GetSalesRankingAvailableYearMonthsResponse>(
      salesRankingQueryKeys.getAvailableYearMonths,
      {},
    ),
  );
